import React from 'react';
import { BrainIcon, ZapIcon, MoonIcon } from 'lucide-react';
export function Problem() {
  return <section id="problem" className="w-full py-12 md:py-24 bg-white" data-id="element-130">
      <div className="container px-4 md:px-6 mx-auto" data-id="element-131">
        <div className="flex flex-col items-center space-y-4 text-center mb-12" data-id="element-132">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-gray-900" data-id="element-133">
            It's 2:47 PM...
          </h2>
          <p className="mx-auto max-w-[700px] text-gray-500 md:text-xl" data-id="element-134">
            You're staring at your laptop, your third espresso has worn off, and
            your brain is fogged out. That big goal you set? Still untouched.
            Your inbox is a graveyard of good intentions.
          </p>
          <p className="mx-auto max-w-[700px] text-gray-500 md:text-xl" data-id="element-135">
            You tell yourself you're ambitious. You read productivity books. You
            even own a vision board. But here's the brutal truth:
          </p>
          <p className="mx-auto max-w-[700px] font-bold text-sage-600 md:text-xl" data-id="element-136">
            You're not making progress.
          </p>
          <p className="mx-auto max-w-[700px] text-gray-500 md:text-xl" data-id="element-137">
            And the worst part? The thing you rely on to fuel your hustle —
            coffee — is the exact thing holding you back.
          </p>
        </div>
        <div className="flex flex-col items-center space-y-4 text-center mt-16 mb-12" data-id="element-138">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl text-gray-900" data-id="element-139">
            Why Coffee Is Keeping You Stuck
          </h2>
          <p className="mx-auto max-w-[700px] text-xl font-medium text-sage-600 mb-8" data-id="element-140">
            Coffee isn't energy. It's an energy loan with interest.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-8" data-id="element-141">
            <div className="flex flex-col items-center p-6 bg-sage-50 rounded-lg" data-id="element-142">
              <BrainIcon className="h-12 w-12 text-sage-600 mb-4" data-id="element-143" />
              <h3 className="text-xl font-bold mb-2" data-id="element-144">Hijacks your brain</h3>
              <p className="text-gray-600 text-center" data-id="element-145">
                Floods you with artificial dopamine, making you feel productive
                while reducing natural motivation.
              </p>
            </div>
            <div className="flex flex-col items-center p-6 bg-sage-50 rounded-lg" data-id="element-146">
              <ZapIcon className="h-12 w-12 text-sage-600 mb-4" data-id="element-147" />
              <h3 className="text-xl font-bold mb-2" data-id="element-148">Spikes cortisol</h3>
              <p className="text-gray-600 text-center" data-id="element-149">
                Keeps you in fight-or-flight mode, killing your ability to think
                clearly.
              </p>
            </div>
            <div className="flex flex-col items-center p-6 bg-sage-50 rounded-lg" data-id="element-150">
              <MoonIcon className="h-12 w-12 text-sage-600 mb-4" data-id="element-151" />
              <h3 className="text-xl font-bold mb-2" data-id="element-152">Ruins your sleep</h3>
              <p className="text-gray-600 text-center" data-id="element-153">
                Caffeine's half-life means it's still in your system at bedtime.
              </p>
            </div>
          </div>
          <p className="text-xl font-medium text-sage-600 mt-8" data-id="element-154">
            Sound familiar?
          </p>
        </div>
      </div>
    </section>;
}